export let PTY_CONFIG = {
  // DEFAULT_PATH : '/tab-home/tab-disciples'
  // DEFAULT_PATH : '/seeker-profile'

  DEFAULT_PATH : '/home'
 // DEFAULT_PATH : '/application'

};